/**
 * cart-drawer-timer.js
 * ---------------------------------------------------------------------------
 * Temporizador de urgencia "Productos Reservados MM:SS" del cart drawer (RF-4).
 *
 * IMPORTANTE: es PERSUASIÓN VISUAL. NO reserva inventario ni bloquea stock real.
 * Solo es una cuenta atrás que vive en el navegador del visitante.
 *
 * - Persiste entre recargas usando localStorage (guarda el instante final).
 *   Si el cliente recarga, ve el mismo tiempo restante (RF-4.2).
 * - Al llegar a 00:00 se reinicia automáticamente y vuelve a contar (RF-4.3).
 * - Los minutos se leen del atributo data-minutes del elemento (configurable
 *   desde el Personalizador del tema).
 *
 * El elemento del temporizador se repinta cada vez que el cajón se refresca,
 * por eso aquí lo buscamos en el DOM en cada tick en lugar de guardarlo.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'cd_timer_end'; // instante (ms) en que la cuenta atrás llega a 0

  function minutesFrom(el) {
    var m = parseInt(el.getAttribute('data-minutes'), 10);
    return m > 0 ? m : 7;
  }

  function newEnd(minutes) {
    return Date.now() + minutes * 60 * 1000;
  }

  function format(remainingMs) {
    var totalSec = Math.floor(remainingMs / 1000);
    var mm = Math.floor(totalSec / 60);
    var ss = totalSec % 60;
    return (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
  }

  function tick() {
    var el = document.querySelector('[data-cd-timer]');
    if (!el) return; // El banner no está presente ahora mismo (carrito vacío, etc.).

    var minutes = minutesFrom(el);
    var maxMs = minutes * 60 * 1000;
    var now = Date.now();
    var end = parseInt(localStorage.getItem(STORAGE_KEY), 10);

    // Sin valor guardado, corrupto, o mayor que el máximo (p. ej. cambiaron los
    // minutos en los ajustes): (re)inicia la cuenta.
    if (!end || isNaN(end) || end - now > maxMs + 2000) {
      end = newEnd(minutes);
      localStorage.setItem(STORAGE_KEY, end);
    }

    var remaining = end - now;
    if (remaining <= 0) {
      // Llegó a cero: reinicia y sigue contando.
      end = newEnd(minutes);
      localStorage.setItem(STORAGE_KEY, end);
      remaining = end - now;
    }

    el.textContent = format(remaining);
  }

  tick();
  setInterval(tick, 1000);
})();
